import { render, staticRenderFns } from "./SalePriceFormItem.vue?vue&type=template&id=322edcd5&"
import script from "./SalePriceFormItem.vue?vue&type=script&lang=ts&"
export * from "./SalePriceFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports